import React from 'react'

const Walking = () => {
  return (
    <div>
      <section class="inner-banner">
        <div class="thm-container">
          <h2> Product Details </h2>
          <div class="breadcumb">
            <a href="/">Chambers</a>
            <i class="fa fa-angle-right"></i>
            <span>Walking Plant Growth Chamber</span>
          </div>
        </div>
      </section>
      <div className='container py-4'>
        <div className='row d-flex' style={{ margin: "80px 0px" }}>
          <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
            <img src='/img/walking.png' width={400}></img>
          </div>
          <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
            <h2 style={{ textDecoration: "underline" }}>Walking Plant Growth Chamber:</h2>
            <h4 style={{ textDecoration: "underline" }}>WLS- 50WPGC, WLS- 80WPGC, WLS- 100WPGC, WLS- 125WPGC, WLS- 150WPGC</h4>
            <p className="mbot25">
              Walk-in Growth Chambers are designed for precise monitoring of temperature, humidity and illumination conditions required for assistance of Seeds & plant growth. These chambers are available in standard or can be tailor made to suit specific requirements.
            </p>
            <p className='mbot25'>
              <h4 style={{ textDecoration: "underline" }}>Features & Benefits:</h4>
              <ul>
                <li>Maintains precise long-term conditions</li>
                <li>Complete solution for simulation of desired Temperature &humidity in the chamber</li>
                <li>Proper illumination by fluorescent Tubes for assistance in growth</li>
                <li> Tailor made sizes as per available space.</li>
                <li> Microprocessor controlled refrigeration system & heaters provide temperature accuracy and reproducible results.</li>
                <li> Illumination by fluorescent tubes for assistance of plant growth.</li>
                <li> Temperature range 20 °C to 60 °C, Accuracy ± 1⁰C.</li>
                <li>Humidity range 40 % to 95 % RH, Accuracy ± 2% RH.</li>
                <li>User friendly LCD screen</li>
                <li>Easy-to-read large display.</li>
                <li> Integrated Data logger for large data storage.</li>
                <li>Variety of options for the graphic display of process parameters &utilities.</li>
                <li>Real time clock for proper data management.</li>
                <li> Electronically controlled humidification system with German humidity sensors.</li>
                <li> Sealed Toughened glass view window on door felicitates sampleviewing.</li>
                <li> Temperature, Humidity and utility failures visual and audiblealarms.</li>
                <li>Stainless steel racks and trays.Fitted with digital temperature controller</li>
                <li>Excellent temperature accuracy & uniformity</li>
                <li>High grade stainless steel interior</li>
                <li>Powder coated exterior cabinet or epoxy coated SS304</li>
                <li>High density glass wool insulation</li>
                <li>Variety of optional accessories available</li>
                <li>Large models are having internal circulation system with inbuilt corrosion resistant pump.</li>
                <li>External circulation available on demand</li>
                <li>Various customized options available</li>
              </ul>
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Walking
